/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    // Liste tous les paramètres (avec filtrage optionnel par catégorie)
    getAll: async (category = null) => {
        const params = new URLSearchParams();
        if (category) params.append('category', category);
        const qs = params.toString();
        const url = qs ? `/admin/settings?${qs}` : '/admin/settings';
        return exeRequest(url, 'GET');
    },

    // Récupère un paramètre par sa clé
    getByKey: async (key) => exeRequest(`/admin/settings/${key}`, 'GET'),

    // Met à jour un paramètre
    update: async (key, value, reason = '') => {
        const body = { value, reason };
        return exeRequest(`/admin/settings/${key}`, 'PUT', body);
    },

    // Crée un nouveau paramètre
    create: async (data) => exeRequest('/admin/settings', 'POST', data),

    // Récupère l'historique d'un paramètre
    getHistory: async (key, limit = 50, offset = 0) => {
        const params = new URLSearchParams({ limit, offset });
        return exeRequest(`/admin/settings/${key}/history?${params.toString()}`, 'GET');
    },

    // Liste les catégories
    getCategories: async () => exeRequest('/admin/settings/categories', 'GET'),

    // Initialise les paramètres par défaut
    seed: async () => exeRequest('/admin/settings/seed', 'POST'),

    // Activer/Désactiver un paramètre
    toggle: async (key, isEnabled, reason = '') =>
        exeRequest(`/admin/settings/${key}/toggle`, 'PATCH', { isEnabled, reason }),
};
